import React, {useEffect, useState} from "react";
import {useSelector} from "react-redux";
import {useDispatch} from "react-redux";
import Footer from "../common/Footer";
import {getTimeZoneDropdownList, getCompanyDetailInfo} from './endpoints/action';
import {companySelector} from "./endpoints/selector";
import { 
  setInitalState
} from "./endpoints/slice";
import CompanyForm from './companyForm';
import useConfiguration from "../../hooks/useConfiguration";
import useSessionStorage from "../../hooks/useSessionStorage";
import Loader from "../common/Loader";
import Header from "../common/Header";
import Sidebar from "../common/Sidebar";
import './addCompany.css';
import Spinner from "../common/Spinner/spinner";
import BankInfoModal from "../common/Modal/BankInfoModal";

// eslint-disable-next-line import/no-anonymous-default-export
export default () => {
    const config = useConfiguration();
    const storage = useSessionStorage();
    const login = storage.getItem('login');
    const {timezoneDropdownList, companyDetailList,loadingFlag} = useSelector(companySelector);
    const [timeZonesDropdownList, setTimeZoneDropdownList] = useState([]);
    const [companyDetailsList, setCompanyDetailsList] = useState([]);
    const [showBankInfoModal,setShowBankInfoModal] = useState({status:false,location:null, getURL:null, postURL:null});
    const dispatch = useDispatch();
    //console.log(timezoneDropdownList);
    useEffect(() => {
        document.title = "Employers Section";
        if(config.baseUrl) {
            dispatch(getTimeZoneDropdownList(config.baseUrl));
            dispatch(getCompanyDetailInfo(config.baseUrl, login.employerId, login.employerUniqueId));
        }
    }, [config]); 

    useEffect(() => {
        if(timezoneDropdownList.length > 0) {
            setTimeZoneDropdownList(timezoneDropdownList);
        }
    }, [timezoneDropdownList]); 

    useEffect(() => {
        if(companyDetailList) {
            setCompanyDetailsList(companyDetailList);
        }
    }, [companyDetailList]); 
    const bankInfoModalHandler = (row) => {
        setShowBankInfoModal((prev) => ({
            ...prev,
            status: true,
            getURL: `BankAccount/get-bank-details-by-employerId?employerUniqueId=${login?.employerUniqueId}`,
            postURL: `BankAccount/bank-account-setupfor-employer`,
          }));
    };
    return(
        <>
         {/* <Loader/> */}
      {loadingFlag > 0 && <Spinner />}

        <Header/>
        <Sidebar/>
        <div className="page main-margin">
            <div className="page-main">
                <div className="main-content app-content mt-0 main-background">
                    <div className="side-app">
                        <div className="main-container container-fluid">
                            <div className="page-header">
                                <div style={{columnGap:"0.5rem"}} className="d-flex align-items-center ">
                                    <h1 className="page-title">Company Detail</h1>
                                    <span>-</span>
                                    <button onClick={bankInfoModalHandler} class="btn btn-success">Add & Edit Bank Info</button>
                                </div>
                                {/* <div>
                                <ol class="breadcrumb">
                                    <li class="breadcrumb-item"><a href="javascript:void(0)">Dashboard</a></li>
                                    <li class="breadcrumb-item active" aria-current="page">Add Company</li>
                                </ol>
                            </div> */}
                            {
                                showBankInfoModal?.status ? <BankInfoModal showBankInfoModal={showBankInfoModal}  updateBankInfoModal={setShowBankInfoModal}/> : null
                            }
                            </div>
                            <div className="row">
                                <div class="col-xl-12">
                                    <div class="card">
                                        <div class="card-body">
                                            <div class="panel panel-primary">
                                                <CompanyForm timeZonesDropdownList={timeZonesDropdownList} companyDetailsList={companyDetailsList} 
                                                   />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-md-12 col-xl-12">
                                    <div class="card">
                                    <div class="card-header">
                                            <h4 class="card-title">Subscribed Shift Types</h4>
                                        </div>
                                        <div class="card-body">
                                            <ul class="list-style5">
                                                
                                                {companyDetailsList.jobTypeList &&

                                                    companyDetailsList.jobTypeList.map(cert => (
                                                        <li>{cert.jobTypes}</li>
                                                    ))
                                                }
                                            </ul>
                                        </div>
                                    </div>  
                                    <div class="col-xl-12"></div>                                  
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer/>
        </div>
        </>
    )
}